import { useState } from 'react'
import Header from '../header/header'
import { LayoutMainStyle } from './layoutMainStyle'
import DrawerCustom from '../drawer/drawer'
interface propsTypes {
    children: any
}
export default function LayoutMain(props: propsTypes) {
    const { children } = props

    const [drawerOpen, setDrawerOpen] = useState<boolean>(false)

    return (
        <LayoutMainStyle>
            <DrawerCustom drawerOpen={drawerOpen} setDrawerOpen={setDrawerOpen} />
            <div style={{ width: "100%", height: '100vh', overflowY: 'auto' }}>
                <Header drawerOpen={drawerOpen} setDrawerOpen={setDrawerOpen} />
                {children}
            </div>
        </LayoutMainStyle>
    )
}
